export default __webpack_public_path__ + "static/media/GalanoGrotesque-Regular.368d21c6.WOFF";